import React from 'react'
import BottomSheetContent from './BottomSheetContent'

interface ESignLearnMoreContentProps {
  onDismiss: () => void
  activationExpiryDate?: number
}

export const ESignLearnMoreContent: React.FC<ESignLearnMoreContentProps> = ({ onDismiss, activationExpiryDate }) => {
  const formattedDate = new Date(activationExpiryDate ?? 0).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short'
  })

  const heading = `Complete eSign before ${formattedDate}`

  return (
    <BottomSheetContent
      heading={heading}
      bottomSheetHeadingClassName='!text-[#3D3D3D] !font-[500] !leading-[140%]'
      onDismiss={onDismiss}
      bottomSheetCtas={
        <button
          onClick={() => {
            onDismiss()
          }}
          className='w-full py-2 px-4 bg-[#232323] text-white font-medium rounded-xl h-14 outline-none focus:outline-none'
        >
          Okay
        </button>
      }
    >
      <div className='flex flex-col gap-4'>
        <div className='text-[14px] font-[400] leading-[150%]'>
          <span className='text-[#6A6E6E]'>eSign needs to be completed within 7 days of payment. </span>
          <span className='text-[#232323]'>In case you decide not to proceed, we'll cancel the membership request and your money will be refunded.</span>
        </div>

        <div className='text-[#6A6E6E] text-[14px] font-[400] leading-[150%]'>
          Note: Your Elite membership will be activated only after you complete eSign. It is mandated by SEBI for all
          advisory services.
        </div>
      </div>
    </BottomSheetContent>
  )
}
